query CustomerGuideDraft($materialId: ID!) {
  customerGuideDraft(materialId: $materialId) {
    draftId
    materialId
    sourcePublishedVersion
    revision
    status
    content
    updatedAt
  }
}
